export const CLOUDLOGINPAGE_UPLOAD_IMAGE_OPEN_MODAL = "CLOUDLOGINPAGE_UPLOAD_IMAGE_OPEN_MODAL";
export const CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST = "CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST";
export const CLOUDLOGINPAGE_UPLOAD_IMAGE_RESULT = "CLOUDLOGINPAGE_UPLOAD_IMAGE_RESULT";

export const CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST = "CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST";
export const CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_RESULT = "CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_RESULT";